import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    minHeight: '124px',
    width: '100%',
    border: '1px dashed #B2B9C0',
    cursor: 'pointer',
    animation: '$fadein 1s',
    boxShadow: 'none',
    transition: 'all 0.15s ease',

    '& > input[type="file"]': {
      display: 'none',
    },

    '&:hover': {
      border: '1px solid #102131',
      boxShadow: '0px 16px 32px rgba(16, 33, 49, 0.08)',
    },
  },
  icon: {
    position: 'relative',
    top: '12px',
    height: '42px',
    width: '42px',
  },
  title: {
    marginTop: '24px',
    marginBottom: '12px',
    color: '#102131',
    fontFamily: '"Manrope3", sans-serif',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  text: {
    color: '#B2B9C0',
    fontSize: '14px',
    textAlign: 'center',
  },
  hint: {
    color: '#B2B9C0',
    fontSize: '12px',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    margin: 10
  },
  preview: {
    height: '100%',
    width: '100%',
    border: '1px dashed #b2b9c0',
    borderRadius: '12px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    animation: '$fadein 1s',

    boxShadow: 'none',
    transition: 'all 0.15s ease',

    '&:hover': {
      border: '1px solid #102131',
      boxShadow: '0px 16px 32px rgba(16, 33, 49, 0.08)',
    },
    '@media(max-width: 900px)': {
      height: '100px',
    },
  },

  deleteBtn: {
    position: 'absolute',
    top: '-16px',
    left: '-12px',
    width: '32px',
    cursor: 'pointer',
  },

  previewTitle: {
    position: 'absolute',
    backgroundColor: '#f2f5f9',
    top: '-12px',
    fontSize: '12px',
    // left: '35%',
  },

  '@keyframes fadein': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  disabled: {
    pointerEvents: 'none',
    '&:hover': {
      boxShadow: 'none',
      cursor: 'not-allowed',
    },
  },
});
